import { useEffect } from 'react';
import type { IipServiceRootResponse } from 'src/apis/iip-service/types';
import { useAxios } from 'src/hooks/use-axios';

type HookConfig = {
  onError?: (error: unknown) => unknown;
};

export function useIipService({ onError }: HookConfig = {}) {
  const request = useAxios(
    (axios, baseConfig) =>
      axios.request<IipServiceRootResponse>({
        ...baseConfig,
        url: PRISMA_CONFIG.iipService,
      }),
    {
      neededOnPageLoad: true,
      cacheKey: 'iip-service-root',
      onError,
    }
  );

  useEffect(() => {
    request.execute();
    // oxlint-disable-next-line exhaustive-deps
  }, []);

  return request;
}

export type IipServiceRequest = ReturnType<typeof useIipService>;
